<template>
  <crud-layout
    :title="title"
    :subtitle="subtitle"
    :add-button="true"
    @add="create"
  >
    <template v-slot:list>
      <oferta-list
        ref="list"
        @update="update"
        @delete="remove"
        @show="show"
      />
    </template>

    <oferta-create
      v-if="creating"
      :open="creating"
      v-on:itemCreated="onItemCreated"
      v-on:close="creating = false"
    />

    <oferta-update
      v-if="updating"
      :open="updating"
      :item="itemToEdit"
      v-on:itemUpdated="onItemUpdated"
      v-on:close="updating = false"
    />

    <oferta-show
      v-if="showing"
      :open="showing"
      :item="itemToShow"
      v-on:close="showing = false"
    />

    <oferta-delete
      v-if="deleting"
      :open="deleting"
      :item="itemToDelete"
      v-on:itemDeleted="onItemDeleted"
      v-on:close="deleting = false"
    />

    <snackbar v-model="flash" />
  </crud-layout>
</template>

<script>
import OfertaCreate from "../OfertaCreate";
import OfertaUpdate from "../OfertaUpdate";
import OfertaDelete from "../OfertaDelete";
import OfertaShow from "../OfertaShow";
import OfertaList from "../OfertaList";

import { CrudLayout, Snackbar } from "@dracul/common-frontend";

export default {
  name: "OfertaCrud",
  components: {
    CrudLayout,
    Snackbar,
    OfertaCreate,
    OfertaUpdate,
    OfertaShow,
    OfertaList,
    OfertaDelete,
  },
  data() {
    return {
      title: "oferta.title",
      subtitle: "oferta.subtitle",
      flash: null,
      creating: false,
      updating: false,
      deleting: false,
      showing: false,
      itemToEdit: null,
      itemToDelete: null,
      itemToShow: null,
    };
  },
  mounted() {
    // Si hay query params con productos, abrir el formulario de creación
    if (this.$route.query.productos) {
      this.creating = true;
    }
  },
  methods: {
    onItemCreated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.created");
      // Limpiar query params
      this.$router.replace({ query: {} });
    },
    onItemUpdated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.updated");
    },
    onItemDeleted() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.deleted");
    },
    create() {
      this.creating = true;
    },
    update(item) {
      this.updating = true;
      this.itemToEdit = item;
    },
    show(item) {
      this.showing = true;
      this.itemToShow = item;
    },
    remove(item) {
      this.deleting = true;
      this.itemToDelete = item;
    },
  },
};
</script>

